import FramePageInner from 'common/view/layouts/frames/FramePageInner';
import { useBodyId, useRootUrl } from 'hooks/common/CommonHook';
import { Outlet } from 'react-router';

const CareerLayout = () => {
  const { currentRootUrl: rootUrl } = useRootUrl();

  let bodyId = '';
  if (rootUrl === 'it') bodyId = 'it_career';
  else if (rootUrl === 'lang') bodyId = 'lang_career';
  else if (rootUrl === 'home') bodyId = 'career';
  useBodyId(bodyId);

  return (
    <FramePageInner>
      <Outlet />
    </FramePageInner>
  );
};

export default CareerLayout;
